<ng-container *ngIf="!!get">
    <ng-container *ngIf="'desktop' | mediaQuery">
        <tt-card ttHeading="h_address" ttAccordion ttRememberId="w_orderhead.card.addresses" ttPersistLocalOnly="false">
            <ng-container [ngTemplateOutlet]="addresses"></ng-container>
        </tt-card>
        <tt-card ttHeading="h_info" ttAccordion ttRememberId="w_orderhead.card.info" ttPersistLocalOnly="false">
            <ng-container [ngTemplateOutlet]="info"></ng-container>
        </tt-card>
        <div>
            <tt-card ttHeading="h_delivery" ttAccordion ttRememberId="w_orderhead.card.delivery" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="delivery"></ng-container>
            </tt-card>
            <tt-card ttHeading="h_customer" ttAccordion ttRememberId="w_orderhead.card.customer" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="customer"></ng-container>
            </tt-card>
        </div>
        <div>
            <tt-card ttHeading="h_price" ttAccordion ttRememberId="w_orderhead.card.price" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="price"></ng-container>
            </tt-card>
            <tt-card>
                <ng-container [ngTemplateOutlet]="buttons"></ng-container>
            </tt-card>
        </div>
    </ng-container>
    <ng-container *ngIf="'laptop' | mediaQuery">
        <div>
            <tt-card ttHeading="h_address" ttAccordion ttRememberId="w_orderhead.card.addresses" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="addresses"></ng-container>
            </tt-card>
            <tt-card>
                <ng-container [ngTemplateOutlet]="buttons"></ng-container>
            </tt-card>
        </div>
        <div>
            <tt-card ttHeading="h_info" ttAccordion ttRememberId="w_orderhead.card.info" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="info"></ng-container>
            </tt-card>
            <tt-card ttHeading="h_customer" ttAccordion ttRememberId="w_orderhead.card.customer" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="customer"></ng-container>
            </tt-card>
        </div>
        <div>
            <tt-card ttHeading="h_delivery" ttAccordion ttRememberId="w_orderhead.card.delivery" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="delivery"></ng-container>
            </tt-card>
            <tt-card ttHeading="h_price" ttAccordion ttRememberId="w_orderhead.card.price" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="price"></ng-container>
            </tt-card>
        </div>
    </ng-container>
    <ng-container *ngIf="'tablet' | mediaQuery">
        <div>
            <tt-card ttHeading="h_address" ttAccordion ttRememberId="w_orderhead.card.addresses" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="addresses"></ng-container>
            </tt-card>
            <tt-card ttHeading="h_delivery" ttAccordion ttRememberId="w_orderhead.card.delivery" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="delivery"></ng-container>
            </tt-card>
            <tt-card ttHeading="h_customer" ttAccordion ttRememberId="w_orderhead.card.customer" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="customer"></ng-container>
            </tt-card>
        </div>
        <div>
            <tt-card ttHeading="h_info" ttAccordion ttRememberId="w_orderhead.card.info" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="info"></ng-container>
            </tt-card>
            <tt-card ttHeading="h_price" ttAccordion ttRememberId="w_orderhead.card.price" ttPersistLocalOnly="false">
                <ng-container [ngTemplateOutlet]="price"></ng-container>
            </tt-card>
            <tt-card *ngIf="showButtonCard">
                <ng-container [ngTemplateOutlet]="buttons"></ng-container>
            </tt-card>
        </div>
    </ng-container>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs #tabs>
                <tt-tab ttId="address" ttLabel="orderhead_address"></tt-tab>
                <tt-tab ttId="terms" ttLabel="orderhead_terms"></tt-tab>
                <tt-tab ttId="adm" ttLabel="orderhead_adm"></tt-tab>
            </tt-tabs>
            <div>
                <ng-container *ngIf="tabs.ttSelectedId === 'address'">
                    <ng-container [ngTemplateOutlet]="addresses"></ng-container>
                </ng-container>
                <ng-container *ngIf="tabs.ttSelectedId === 'terms'">
                    <tt-tabs #termTabs>
                        <tt-tab ttId="del" ttLabel="orderhead_termdelivery"></tt-tab>
                        <tt-tab ttId="price" ttLabel="orderhead_termprice"></tt-tab>
                    </tt-tabs>
                    <ng-container *ngIf="termTabs.ttSelectedId === 'del'" [ngTemplateOutlet]="delivery"></ng-container>
                    <ng-container *ngIf="termTabs.ttSelectedId === 'price'" [ngTemplateOutlet]="price"></ng-container>
                </ng-container>
                <ng-container *ngIf="tabs.ttSelectedId === 'adm'">
                    <ng-container [ngTemplateOutlet]="info"></ng-container>
                    <ng-container [ngTemplateOutlet]="customer"></ng-container>
                </ng-container>
                <ng-container [ngTemplateOutlet]="buttons"></ng-container>
            </div>
        </tt-card>
    </ng-container>

    <ng-template #addresses>
        <tt-order-head-address-form
            [get]="get"
            [customerForm]="customerForm"
            [deliveryForm]="deliveryForm"
            [invoiceForm]="invoiceForm"
            [customerPersons]="customerPersons"
            [businesses]="businesses"
            [coops]="coops"
            [countries]="countries"
        ></tt-order-head-address-form>
    </ng-template>
    <ng-template #customer>
        <tt-order-head-customer-form [get]="get" [form]="customerForm" [customerPersons]="customerPersons"></tt-order-head-customer-form>
    </ng-template>
    <ng-template #delivery>
        <tt-order-head-delivery-form [get]="get" [form]="deliveryForm" [deliveryMethods]="deliveryMethods" [pickJobGroups]="pickJobGroups"></tt-order-head-delivery-form>
    </ng-template>
    <ng-template #price>
        <tt-order-head-price-form
            [get]="get"
            [form]="invoiceForm"
            [deliveryTerms]="deliveryTerms"
            [payments]="payments"
            [pricelists]="pricelists"
            [factorings]="factorings"
            [valutas]="valutas"
            [invoiceMethods]="invoiceMethods"
            [taxes]="taxes"
            [discount2s]="discount2s"
            [collections]="collections"
        ></tt-order-head-price-form>
    </ng-template>
    <ng-template #info>
        <tt-order-head-info-form
            [get]="get"
            [form]="infoForm"
            [companies]="companies"
            [portalUsers]="portalUsers"
            [orderMethods]="orderMethods"
            [stockplaces]="stockplaces"
            [sellers]="sellers"
            [departments]="departments"
            [orderHeadProvider]="getOrderHeadFromForm"
            (converted)="saved.emit()"
        ></tt-order-head-info-form>
    </ng-template>
    <ng-template #buttons>
        <tt-button-save *ngIf="hasUnsavedChanges" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto
            *ngIf="get.orderconfirm_reportdef_keyno > ''"
            ttText="orderhead_orderconfirm"
            [ttBeforeGoto]="saveWithErrorThrow"
            ttGoto="printpreview"
            [ttGotoParms]="{
                argtype: 'order_internal_no',
                webpage: 'orderhead',
                argvalue: get.order_internal_no,
                report_keyno: get.orderconfirm_reportdef_keyno,
                printer_keyno: '0',
            }"
        ></tt-button-goto>
        <tt-button *ngIf="get.delivered === '0'" ttType="danger" ttText="orderhead_delivery" ttIcon="fad fa-truck" (ttClick)="deliver()" [ttLoading]="delivering"></tt-button>
    </ng-template>
</ng-container>
